import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'button', 'showIcon', 'hideIcon'];

  static values = {
    showLabel: { type: String, default: 'Afficher le mot de passe' },
    hideLabel: { type: String, default: 'Masquer le mot de passe' },
  };

  connect() {
    this.syncState();
  }

  toggle() {
    if (!this.hasInputTarget) return;

    this.inputTarget.type = this.inputTarget.type === 'password' ? 'text' : 'password';
    this.syncState();
  }

  syncState() {
    if (!this.hasInputTarget || !this.hasButtonTarget) return;

    const visible = this.inputTarget.type === 'text';
    const label = visible ? this.hideLabelValue : this.showLabelValue;

    if (this.hasShowIconTarget) {
      this.showIconTarget.classList.toggle('hidden', visible);
    }

    if (this.hasHideIconTarget) {
      this.hideIconTarget.classList.toggle('hidden', !visible);
    }

    this.buttonTarget.setAttribute('aria-label', label);
    this.buttonTarget.setAttribute('title', label);
    this.buttonTarget.setAttribute('aria-pressed', visible ? 'true' : 'false');
  }
}
